"use client"

import { useAnalyticsOptOut } from "@src/hooks/useAnalyticsOptOut"

/**
 * Dynamic analytics opt-in/out for marketing routes, mirroring the app's
 * TrackingProvider. Without it, a user who was opted out on a sensitive
 * or private-mode route would stay opted out forever on marketing pages,
 * silently dropping all landing events.
 */
export function MarketingTracking() {
  useAnalyticsOptOut()
  return null
}
